export enum DrawingType {
    Note = "Note",
    Polyline = "Polyline",
    Polygon = "Polygon",
    Paint = "Paint",
    ImagePlane = "ImagePlane"
}
